import { createSlice } from '@reduxjs/toolkit';

const smartMatchSlice = createSlice({
  name: 'smartMatch',
  initialState: {
    smartMatchResults: [],
    smartMatchJobDetails: null,
  },
  reducers: {
    setSmartMatchResults: (state, action) => {
      state.smartMatchResults = action.payload;
    },
    setSmartMatchJobDetails: (state, action) => {
      state.smartMatchJobDetails = action.payload;
    },
    clearSmartMatch: (state) => {
      state.smartMatchResults = [];
      state.smartMatchJobDetails = null;
    }
  },
});

export const { setSmartMatchResults, setSmartMatchJobDetails, clearSmartMatch } = smartMatchSlice.actions;
export default smartMatchSlice.reducer;